export const ADMIN_PHONG_HOP_PREFIX_URL = '/admin-phong-hop'
